import { useEffect } from 'react';

import { cssVar, use100vh } from 'ovpn-ui-toolkit';

/**
 * 100vh is not giving us real device height
 * in case of Android Chrome and Safari dynamic bar
 *  (both remove some usable height from 100vh).
 *
 * To not call use100vh everywhere, we can just put it value to css variable.
 */
export function useSetupCssVariables() {
    const deviceHeight = use100vh();

    useEffect(() => {
        cssVar.set('--true-100vh', deviceHeight);
    }, [deviceHeight]);
}
